/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import { useMemo } from "react";
import OrderDetails from "../../components/OrderDetails";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import NotificationsPausedIcon from "@mui/icons-material/NotificationsPaused";
import ModalComponent from "components/ModalComponent";

function BodyMShapes({ _id }) {
  const navigate = useNavigate();

  const [bodyData, setBodyData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/bodyData/getBodyMeasurementGuide`
      );
      console.log("Full Response:", response);

      const bodyData = response?.data?.data?.bodyData || [];
      console.log(bodyData, "Body Data");
      setBodyData(bodyData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  //-----------------------------Delete api---------------------------------//
  const deleteBodyDataImages = async (_id) => {
    console.log(_id, "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    try {
      const isConfirmed = window.confirm("Are you sure you want to delete this item?");
      if (!isConfirmed) return;

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/bodyData/deleteBodyDataImages/${_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      fetchData();

      if (!response.ok) {
        throw new Error("Failed to delete data");
      }
      const data = await response.json();
      console.log("Body data images deleted successfully:", data);
    } catch (error) {
      console.error("Error deleting body data images:", error.message);
    }
  };

  const handleDeleteButtonClick = (_id) => {
    deleteBodyDataImages(_id);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const handleShowOrderDetails = () => {
    setShowOrderDetails(true);
  };
  const handleHideOrderDetails = () => {
    setShowOrderDetails(false);
  };

  const rows = useMemo(
    () =>
      bodyData &&
      bodyData.map((data, index) => ({
        ...data,
        id: data._id,
      }))
  );

  const columns = [
    // { field: "_id", headerName: "ID", width: 90 },
    {
      field: "Orderid",
      headerName: "Order Id",
      width: 150,
      editable: true,
    },

    {
      field: "customerId",
      headerName: "Customer Id",
      width: 150,
      editable: true,
    },

    {
      field: "storeId",
      headerName: "Store Id",
      width: 150,
      editable: true,
    },

    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip title="Track">
                <IconButton>
                  <MdOutlinePreview
                    onClick={(e) => {
                      handleOpenModal();
                      e.stopPropagation();
                    }}
                    className="text-gray-400 cursor-pointer text-xl"
                  />
                </IconButton>
              </Tooltip>
              {/* </div> */}
              <ModalComponent title={"Reviews"} open={openModal} handleClose={closeModal}>
                <textarea
                  id="w3review"
                  name="w3review"
                  rows="4"
                  cols="50"
                  style={{
                    height: 200,
                    width: "800px",
                    background: "white",
                    border: "1px solid black",
                    marginTop: "5%",
                    fontSize: "15px",
                  }}
                  defaultValue={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`}
                />
              </ModalComponent>
              <ModalComponent
                title={" Order Details"}
                open={showOrderDetails}
                handleClose={handleHideOrderDetails}
              >
                <OrderDetails order={param.row} />
              </ModalComponent>

              <div>
                <Tooltip title="Ignored" style={{ color: "red" }}>
                  <IconButton onClick={() => navigate("/Ignored")}>
                    <NotificationsPausedIcon style={{ cursor: "pointer" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Box sx={{ height: 595, width: "100%", background: "white" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[10]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BodyMShapes;